import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Relatorio Analitico',
    path: 'relatorio-analitico',
    name: 'recebimentoitemanaliticoceramica',
    component: () => import('@/views/dashboard/recebimento-item/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Relatorio],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Recebimento Consolidado',
    path: 'recebimento-consolidado',
    name: 'recebimentoconsolidadoceramica',
    component: () => import('@/views/dashboard/recebimento/Index.vue'),
    meta: { utlTipoFornecimentoId: 101, permissions: [EPermissoes.Relatorio], escopoObra: 'obra' },
    goesToMenu: true
  },
  {
    description: 'Ensaio Consolidado',
    path: 'ensaio-consolidado',
    name: 'ensaioconsolidadoanaliticoceramica',
    component: () => import('@/views/dashboard/ensaio-consolidado/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 101,
      permissions: [EPermissoes.Relatorio],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
];



